import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import S from './receiveReleaseAll.scss';
import ColoredButton from 'components/ColoredButton';
import ConfirmDialog from 'components/ConfirmDialog';
import { savePhaseItem } from 'actionCreators/phase_items';

const WAREHOUSE_MERCH_ITEM_TYPE = 'warehouseMerchandiseItems';
const WAREHOUSE_PADS_ITEM_TYPE = 'phaseLineItems';

class ReceiveReleaseAll extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalActive: false,
      title: '',
      status: '',
    };
  }

  toggleModalActive = () => {
    this.setState({ modalActive: !this.state.modalActive });
  }

  handleReceiveRelease = (action) => {
    if (action === 'receive') {
      this.setState({ modalActive: true,
        title: 'Receive All',
        status: 'In Warehouse',
      });
    } else {
      this.setState({ modalActive: true,
        title: 'Release All',
        status: 'Released',
      });
    }
  }

  handleConfirm = () => {
    const { warehouseMerch, warehousePads, phaseId } = this.props;
    const { title } = this.state;

    if (title === 'Receive All') {
      this.receiveMerch(warehouseMerch, phaseId);
    } else if (title === 'Release All') {
      this.releaseWarehouseMerch(warehouseMerch, phaseId);
      this.releaseWarehousePads(warehousePads, phaseId);
    }
    this.toggleModalActive();
  }

  receiveMerch = (merch, phaseId) => {
    if (merch.length > 1) {
      merch.forEach((item) => {
        if (item.id > 0) {
          const lineItem = item;
          lineItem.status = this.state.status;
          this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_MERCH_ITEM_TYPE);
        }
      });
    }
  }

  releaseWarehouseMerch = (merch, phaseId) => {
    if (merch.length > 0) {
      merch.forEach((item) => {
        if (item.id > 0) {
          const lineItem = item;
          lineItem.status = this.state.status;
          this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_MERCH_ITEM_TYPE);
        }
      });
    }
  }

  releaseWarehousePads = (pads, phaseId) => {
    if (pads.length > 0) {
      pads.forEach((pad) => {
        const lineItem = pad;
        lineItem.warehouse_status = this.state.status;
        this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_PADS_ITEM_TYPE);
      });
    }
  }


  render() {
    const { modalActive, status } = this.state;

    return (
      <div className={S.container}>
        <ColoredButton
          color="green"
          label="Receive All"
          className={S.receive}
          onClick={() => this.handleReceiveRelease('receive')}
        />
        <ColoredButton
          color="yellow"
          label="Release All"
          className={S.release}
          onClick={() => this.handleReceiveRelease('release')}
        />
        {modalActive &&
          <ConfirmDialog
            title={`Mark all items as '${status}'?`}
            okLabel="Yes"
            cancelLabel="Cancel"
            cancel={this.toggleModalActive}
            dismiss={this.toggleModalActive}
            proceed={this.handleConfirm}
          />
        }
      </div>
    );
  }
}

ReceiveReleaseAll.propTypes = {
  warehouseMerch: PropTypes.array,
  warehousePads: PropTypes.array,
  savePhaseItem: PropTypes.func,
  phaseId: PropTypes.number,
};

export default connect(null, { savePhaseItem })(ReceiveReleaseAll);



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/components/receiveReleaseAll.jsx